module.exports = __webpack_public_path__ + "img/bannerRed.77a9af23.jpg";